import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Layout,
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Breadcrumb,
  Space,
} from "antd";

import { useBackend } from "backend/useBackend";
// import { showLoader } from "utils/loader";
// import { message } from "antd";

const { Content } = Layout;

const endpoint = "scraping";

const Add = () => {
  const navigate = useNavigate();

  const { addItem } = useBackend("http://localhost:2000/");

  const onFinish = (values) => {
    const payload = {
      ...values,
    };
    // const key = "scraping";
    // showLoader(true);
    // message.loading({ content: "Scrapping...", key });
    // fetch("http://localhost:2000/scraping/by-url", {
    //   method: "POST",
    //   body: JSON.stringify(payload),
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then(async (response) => {
    //     showLoader(false);
    //     const result = await response.json();
    //     console.log("response", response);
    //     console.log("result", result);
    //     if (!response.ok) {
    //       return message.error({ content: result.message, key });
    //       // throw new Error(res.message);
    //     }
    //     return result;
    //   })
    //   .then((data) => {
    //     message.success({ content: data.message, key });
    //     navigate("/scraping/confirm", { state: data.items });
    //     console.log("data", data);
    //   });
    // .catch((e) => {
    //   message.error({ content: e.message, key });
    //   console.log(e);
    // });
    addItem(`${endpoint}/by-url`, payload, {
      // redirectTo: endpoint,
      loader: true,
      msg: {
        loading: "scrapping...",
      },
    }).then((data) => {
      navigate("/scraping/confirm", {
        state: {
          url: values.url,
          items: data.items,
        },
      });
    });
  };

  const onFinishFailed = (data) => console.log(data);

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Quotes</Breadcrumb.Item>
        <Breadcrumb.Item>Add By Url</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={12}>
        <Col md={12}>
          <Card title="Add URL">
            <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              size={"large"}
            >
              <Form.Item
                className="mb-2"
                label="URL"
                name="url"
                rules={[{ required: true, message: "URL is required" }]}
                size={"large"}
              >
                <Input placeholder={"https://www.xyz.com/"} />
              </Form.Item>
              <Form.Item>
                <Row justify="end" style={{ marginTop: "2em" }}>
                  <Col>
                    <Space size="small">
                      <Button type="primary" htmlType="submit" size="large">
                        Scrap
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default Add;
